import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import { BuildingsTable } from '../Table/BuildingsTable';
import { BuildingsTableControls } from '../Controls/Controls';
import { CreateBuildingModal } from '../Modals/Create/Create';
import { EditBuildingModal } from '../Modals/Edit/Edit';
import { RemoveBuildingModal } from '../Modals/Remove/Remove';
import { useBuildings } from './use-buildings';
import { buildingsFilterFields } from './filter-fields';

export const Buildings = () => {
  const { state, methods } = useBuildings();

  return (
    <>
      <BuildingsTableControls
        createBuilding={methods.createBuilding}
        columns={state.columns}
        visibleKeys={state.visibleKeys}
        setVisibleKeys={methods.setVisibleKeys}
        showSider={methods.showSider}
        filterCount={state.filterCount}
      />
      <BuildingsTable
        loading={state.loading}
        dataSource={state.buildings}
        columns={state.filteredColumns}
        tableState={state.tableState}
        onChange={methods.onTableChange}
      />
      <CreateBuildingModal
        selectedBuilding={state.selectedBuilding}
        visible={state.createModalVisible}
        hide={() => methods.setCreateModalVisible(false)}
      />
      <EditBuildingModal
        selectedBuilding={state.selectedBuilding}
        visible={state.editModalVisible}
        hide={methods.hideEditModal}
        onItemEdit={methods.refreshPage}
      />
      <RemoveBuildingModal
        selectedBuilding={state.selectedBuilding}
        visible={state.removeModalVisible}
        hide={() => methods.setRemoveModalVisible(false)}
        onItemRemove={methods.onItemRemove}
      />
      <AppSider
        title="Фильтры"
        isSiderVisible={state.siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={methods.hideSider}
      >
        <TableFilter
          fields={buildingsFilterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={methods.onFilterChange}
          onClose={methods.hideSider}
          fieldsValue={state.filterState}
        />
      </AppSider>
    </>
  );
};
